import {CustomCellRendererProps} from '@ag-grid-community/react';
import {IconMessage} from "@tabler/icons-react";

export type CommentCellProps = CustomCellRendererProps<never, boolean> & {}

export const CommentCell = (props: CommentCellProps) => {
  const {value} = props
  return value ? <IconMessage size={14}/> : undefined;
}
